<script setup lang="ts">
    import DeleteButton from '@/components/DeleteButton.vue';
    import type { Employee } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { formatCurrency, formatDate } from '@/utils/helpers';
    import {
        Table,
        TableHeader,
        TableBody,
        TableRow,
        TableCell,
        TableHead,
    } from '@/components/ui/table';
    import { ref } from 'vue';
    import { Label } from '@/components/ui/label';
    import { type InertiaForm } from '@inertiajs/vue3';

    const props = defineProps<{
        employee: Employee;
        form: InertiaForm<Employee>;
    }>();

    const { t } = useI18n();

    const futureSalaryChanges = ref(props.employee.employment.future_salary_changes || []);

    const deleteFutureSalaryChange = (future_salary_change: { id: number }) => {
        props.form.employment.deleted_future_salary_changes.push(future_salary_change.id);

        futureSalaryChanges.value = futureSalaryChanges.value.filter(
            (item: { id: number }) => item.id !== future_salary_change.id,
        );
    };
</script>

<template>
    <div
        v-if="!!futureSalaryChanges.length"
        class="grid gap-3"
    >
        <Label>{{ $t('employee.employment.future_salary_changes') }}</Label>
        <div class="border-secondary grid gap-3 rounded-md border p-2.5">
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead class="h-8">{{ t('employee.employment.salary') }}</TableHead>
                        <TableHead class="h-8">
                            {{ t('employee.employment.future_salary_starts_at') }}
                        </TableHead>
                        <TableHead class="h-8"></TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <TableRow
                        v-for="future_salary_change in futureSalaryChanges"
                        :key="future_salary_change.id"
                    >
                        <TableCell class="h-8">
                            {{ formatCurrency(future_salary_change.amount) }}
                        </TableCell>
                        <TableCell class="h-8">
                            {{ formatDate(future_salary_change.starts_at) }}
                        </TableCell>
                        <TableCell class="h-8 w-0 py-1 whitespace-nowrap">
                            <DeleteButton @click="deleteFutureSalaryChange(future_salary_change)" />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    </div>
</template>
